/*!
 * (C) PAQT.com B.V. https://paqt.com - MIT License
 */
import { parseDayMonthYearDate, printDayMonthYearDate } from '../../utils/date';
const dayMonthYearAdapter = { parse: parseDayMonthYearDate, format: printDayMonthYearDate };
export default dayMonthYearAdapter;
//# sourceMappingURL=date-adapter.js.map
